// import axios from "axios";
// import React, { useEffect, useState } from "react";
// import { FaRegEdit } from "react-icons/fa";
// import { MdOutlineCreateNewFolder, MdOutlineDelete } from "react-icons/md";
// import CreateLeaveCatPopup from "./CreateLeaveCatPopup";
// import { base_url } from "../../../utils/AxiosConfig";
// import { FallingLines } from "react-loader-spinner";
// import EditLeaveCatPopup from "./EditLeaveCatPopup";
// import DeleteCategoryPop from "./DeleteCategoryPop";
// import { FaSearch } from "react-icons/fa";

// const LeaveCategory = () => {
//   const storedUserDataArray =
//     JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
//   let companyCode = null;

//   if (storedUserDataArray) {
//     companyCode = storedUserDataArray[0].cmpcode;
//   }

//   const [loader, setLoader] = useState(true);
//   const [LeaveData, setLeaveData] = useState(null);
//   const [SearchData, setSearchData] = useState(null);
//   const [LeaveCatName, setLeaveCatName] = useState(null);
//   const [CloseUpdate, setCloseUpdate] = useState(false);
//   const [showModal, setShowModal] = useState(false);
//   const [showCreatePopup, setShowCreatePopup] = useState(false);

//   const [isModalVisible, setModalVisible] = useState(true);

//   const [deleteCatName, setDeleteCatName] = useState("");

//   // pagination
//   const [currentPage, SetcurrentPage] = useState(1);
//   const recordsPerPage = 10;
//   const lastIndex = currentPage * recordsPerPage;
//   const firstIndex = lastIndex - recordsPerPage;
//   const records = LeaveData?.slice(firstIndex, lastIndex);
//   const npage = Math.ceil(LeaveData?.length / recordsPerPage);
//   const numbers = Array.from({ length: npage }, (_, i) => i + 1);

//   const getLeave = async () => {
//     try {
//       const response = await axios.get(
//         `${base_url}/api/PersonalInfoLeaveCategoryList/${companyCode}/ALL/-`,
//       );
//       if (response?.data) {
//         setLeaveData(response.data);
//       } else {
//         console.log("error");
//       }
//     } catch (error) {
//       console.error("PersonalInfoLeaveCategoryListEerror:", error);
//     }
//   };

//   useEffect(() => {
//     getLeave();
//   }, []);

//   const handleClose = () => {
//     setCloseUpdate(CloseUpdate === true ? false : true);
//   };
//   const handleCreateClick = () => {
//     setShowCreatePopup(false);
//   };

//   useEffect(() => {
//     const getLeave = async () => {
//       try {
//         const response = await axios.get(
//           `${base_url}/api/PersonalInfoLeaveCategoryList/${companyCode}/ALL/-`,
//         );
//         if (response?.data) {
//           setLeaveData(response.data);
//         } else {
//           console.log("error");
//         }
//       } catch (error) {
//         console.error("PersonalInfoLeaveCategoryListEerror:", error);
//       }
//     };

//     getLeave();
//   }, [CloseUpdate]);

//   useEffect(() => {
//     if (LeaveData === null) {
//       setLoader(true);
//     } else if (LeaveData) {
//       setLoader(false);
//     }
//   }, [LeaveData]);

//   useEffect(() => {
//     const getSearchData = async () => {
//       const response = await axios.get(
//         `${base_url}/api/PersonalInfoLeaveCategoryList/${companyCode}/FREETEXT/${SearchData}`,
//       );
//       if (response?.data) {
//         setLeaveData(response.data);
//       } else {
//         console.log("error");
//       }
//     };
//     if (SearchData) {
//       getSearchData();
//     } else {
//       const getLeave = async () => {
//         try {
//           const response = await axios.get(
//             `${base_url}/api/PersonalInfoLeaveCategoryList/${companyCode}/ALL/-`,
//           );
//           if (response?.data) {
//             setLeaveData(response.data);
//           } else {
//             console.log("error");
//           }
//         } catch (error) {
//           console.error("PersonalInfoLeaveCategoryList:", error);
//         }
//       };

//       getLeave();
//     }
//   }, [SearchData]);

//   return (
//     <div className="mx-auto px-4">
//       <div className="w-full overflow-auto">
//         {/* <div className="flex flex-wrap items-center justify-between mb-4"> */}
//         {/* <div className="w-2/3"> */}
//         {/* <MdPersonAddAlt className="mr-2" /> */}
//         {/* <div>

// <h6 className="text-2xl font-bold text-gray-600 flex  justify-start items-center">
// <span>
// Leave Category
// </span>
// </h6>
// </div> */}

//         <div className=" w-full flex justify-between items-center ">
//           <div className="flex justify-left items-center">
//             <div className="w-1 h-8 bg-gradient-to-r from-[#2663EB] to-blue-400 rounded-full  mr-2"></div>
//             <h6 className="text-xl font-bold text-gray-900 flex items-center gap-4">
//               <span className="bg-gradient-to-r from-[#2663EB] to-blue-600 bg-clip-text text-transparent">
//                 LEAVE CATEGORY
//               </span>
//             </h6>
//           </div>

//           {/* <div className="flex justfy-between items-center"> */}
//           <div className="relative">
//             <FaSearch className="absolute top-4 left-3 text-gray-400" />
//             <input
//               type="text"
//               placeholder="Search Category..."
//               className="pl-10 bg-white pr-4 py-2 my-1 border border-gray-700 rounded w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
//               onChange={(e) => setSearchData(e.target.value)}
//             />
//           </div>
//           <div className="group">
//             <button
//               type="button"
//               className="ml-4 border border-green-500 hover:bg-green-700  text-white bg-green-600   font-medium py-1 px-2 rounded  flex items-center justify-center transition-colors duration-200"
//               // onClick={handleClose}
//               onClick={handleCreateClick}
//             >
//               <div className="flex justify-between items-center group-hover:animate-bounce ">
//                 <MdOutlineCreateNewFolder className="mr-2 " />
//                 <span className="">Create</span>
//               </div>
//             </button>
//           </div>
//           {/* </div> */}
//         </div>
//         {/* </div> */}

//         <div className="overflow-x-auto mt-2">
//           {records ? (
//             <table className="shadow-sm min-w-full bg-white rounded-sm border border-gray-300 text-xs  ">
//               <thead>
//                 <tr className="bg-[#2663EB] text-white">
//                   <th className="px-2 py-1 border-none font-normal w-5">Sl</th>
//                   <th className="px-2 py-1 border-none font-normal w-15">
//                     Code
//                   </th>
//                   <th className="px-2 py-1 border-none font-normal w-25">
//                     Leave Category
//                   </th>
//                   <th className="px-2 py-1 border-none font-normal w-25">
//                     Validity From
//                   </th>
//                   <th className="px-2 py-1 border-none font-normal w-25">
//                     Validity To
//                   </th>
//                   <th className="px-2 py-1 border-none font-normal w-15">
//                     Type
//                   </th>
//                   <th className="px-2 py-1 border-none font-normal text-center w-5">
//                     Actions
//                   </th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {records.map((d, i) => (
//                   <tr key={i} className="border hover:bg-gray-50">
//                     <td className="px-2 py-1 border">{i + 1}</td>
//                     <td className="px-2 py-1 border">{d?.code}</td>
//                     <td className="px-2 py-1 border">{d?.name}</td>
//                     <td className="px-2 py-1 border">{d?.validity_From}</td>
//                     <td className="px-2 py-1 border">{d?.Validity_To}</td>
//                     <td className="px-2 py-1 border">{d?.type}</td>
//                     <td className="px-2 py-1 flex justify-center items-center gap-2">
//                       {/* <div className=""> */}
//                       <button
//                         className="flex items-center bg-red-500 hover:bg-red-700 text-white px-1 py-1 rounded-lg shadow-sm transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-red-300"
//                         onClick={() => {
//                           setDeleteCatName(d?.name);
//                           setModalVisible(true);
//                         }}
//                       >
//                         <MdOutlineDelete className="text-xl" />
//                       </button>

//                       <button
//                         className="flex items-center gap-1 bg-blue-500 hover:bg-blue-700 text-white px-1 py-1 rounded-lg shadow-sm transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-blue-300"
//                         onClick={() => setLeaveCatName(d?.name)}
//                       >
//                         <FaRegEdit className="text-lg" />
//                         {/* <span>Edit</span> */}
//                       </button>
//                       {/* </div> */}
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           ) : null}
//         </div>

//         <EditLeaveCatPopup
//           LeaveCatName={LeaveCatName}
//           handleClose={handleClose}
//         />

//         <DeleteCategoryPop
//           deleteCatName={deleteCatName}
//           handleClose={handleClose}
//           setModalVisible={setModalVisible}
//           isModalVisible={isModalVisible}
//         />

//         {records ? (
//           <div className="flex justify-end mt-4">
//             <nav>
//               <ul className="inline-flex items-center space-x-2">
//                 {currentPage !== 1 && (
//                   <li>
//                     <button
//                       className="px-3 py-1 border rounded hover:bg-gray-200"
//                       onClick={prePage}
//                     >
//                       Previous
//                     </button>
//                   </li>
//                 )}
//                 {numbers.map((n, i) => (
//                   <li key={i}>
//                     <button
//                       className={`px-2 py-1 border rounded ${
//                         currentPage === n
//                           ? "bg-blue-600 text-white"
//                           : "hover:bg-blue-200"
//                       }`}
//                       onClick={() => changeCPage(n)}
//                     >
//                       {n}
//                     </button>
//                   </li>
//                 ))}
//                 {currentPage !== numbers[numbers.length - 1] && (
//                   <li>
//                     <button
//                       className="px-3 py-1 border rounded hover:bg-gray-200"
//                       onClick={nextPage}
//                     >
//                       Next
//                     </button>
//                   </li>
//                 )}
//               </ul>
//             </nav>
//           </div>
//         ) : null}

//         {loader && (
//           <div className="flex justify-center items-center mt-5">
//             <p className="text-center text-gray-600 flex items-center">
//               Please Wait Loading Data... &nbsp;
//               <FallingLines />
//             </p>
//           </div>
//         )}
//       </div>

//               {showCreatePopup && (
//           <CreateLeaveCatPopup handleClose={handleClose} getLeave={getLeave} />
//         )}
//     </div>
//   );

//   function prePage() {
//     if (currentPage !== firstIndex) {
//       SetcurrentPage(currentPage - 1);
//     }
//   }
//   function changeCPage(id) {
//     SetcurrentPage(id);
//   }

//   function nextPage() {
//     if (currentPage !== lastIndex) {
//       SetcurrentPage(currentPage + 1);
//     }
//   }
// };

// export default LeaveCategory;

import axios from "axios";
import React, { useEffect, useState } from "react";
import { FaRegEdit, FaSearch } from "react-icons/fa";
import { MdOutlineCreateNewFolder, MdOutlineDelete } from "react-icons/md";
import CreateLeaveCatPopup from "./CreateLeaveCatPopup";
import EditLeaveCatPopup from "./EditLeaveCatPopup";
import DeleteCategoryPop from "./DeleteCategoryPop";
import { base_url } from "../../../utils/AxiosConfig";
import { FallingLines } from "react-loader-spinner";

const LeaveCategory = () => {
  const storedUserDataArray =
    JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];

  const companyCode = storedUserDataArray?.[0]?.cmpcode;

  const [loader, setLoader] = useState(true);
  const [LeaveData, setLeaveData] = useState([]);
  const [SearchData, setSearchData] = useState("");
  const [LeaveCatName, setLeaveCatName] = useState(null);
  const [showCreatePopup, setShowCreatePopup] = useState(false);
  const [showEditPopup, setShowEditPopup] = useState(false);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [deleteCatName, setDeleteCatName] = useState(null);
  const [isModalVisible, setModalVisible] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 10;

  const lastIndex = currentPage * recordsPerPage;
  const firstIndex = lastIndex - recordsPerPage;

  const records = LeaveData.slice(firstIndex, lastIndex);
  const npage = Math.ceil(LeaveData.length / recordsPerPage);
  const numbers = [...Array(npage + 1).keys()].slice(1);

  const getLeave = async () => {
    try {
      const res = await axios.get(
        `${base_url}/api/PersonalInfoLeaveCategoryList/${companyCode}/ALL/-`,
      );
      setLeaveData(res.data || []);
      setLoader(false);
    } catch (err) {
      console.log(err);
      setLoader(false);
    }
  };

  useEffect(() => {
    getLeave();
  }, []);

  const handleClose = () => {
    setShowCreatePopup(false);
    setLeaveCatName(null);
    setModalVisible(false);
    setShowDeletePopup(false);
    setShowEditPopup(false);
  };

  const handleCreateClick = () => {
    setShowCreatePopup(true);
  };
  const handleEditClick = (leaveName) => {
    setLeaveCatName(leaveName)
    setShowEditPopup(true);
  };
  const handleDeleteClick = (name) => {
    setDeleteCatName(name);
    setShowDeletePopup(true);
    console.log("Delete Clicked!")
  };

  useEffect(() => {
    const fetchSearch = async () => {
      if (!SearchData) return getLeave();

      const res = await axios.get(
        `${base_url}/api/PersonalInfoLeaveCategoryList/${companyCode}/FREETEXT/${SearchData}`,
      );

      setLeaveData(res.data || []);
    };

    fetchSearch();
  }, [SearchData]);

  return (
    <div className="w-full px-4">
      {/* HEADER */}
      <div className="flex justify-between items-center mb-4">
        <div className="flex items-center gap-2">
          <div className="w-1 h-8 bg-gradient-to-r from-[#2663EB] to-blue-400 rounded"></div>
          <h2 className="text-xl font-bold bg-gradient-to-r from-[#2663EB] to-blue-600 bg-clip-text text-transparent">
            LEAVE CATEGORY
          </h2>
        </div>

        {/* SEARCH */}
        <div className="flex items-center gap-4">
          <div className="relative">
            <FaSearch className="absolute top-3 left-3 text-gray-400" />
            <input
              type="text"
              placeholder="Search Category..."
              onChange={(e) => setSearchData(e.target.value)}
              className="pl-9 pr-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
            />
          </div>

          {/* CREATE BUTTON */}
          <button
            onClick={handleCreateClick}
            className="flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg shadow-sm transition"
          >
            <MdOutlineCreateNewFolder />
            Create
          </button>
        </div>
      </div>

      {/* TABLE */}
      <div className="overflow-x-auto bg-white rounded-lg shadow-sm border">
        <table className="w-full text-sm">
          <thead className="bg-[#2663EB] text-white">
            <tr>
              <th className="p-2">Sl</th>
              {/* <th className="p-2">Code</th> */}
              <th className="p-2">Leave Category</th>
              <th className="p-2">Gender</th>
              <th className="p-2">Unit</th>
              <th className="p-2">Carry Forward</th>
              <th className="p-2">Effective After</th>
              <th className="p-2">Encashment</th>
              <th className="p-2">Type</th>
              <th className="p-2">Rest List</th>
              <th className="p-2 text-center">Actions</th>
            </tr>
          </thead>

          <tbody>
            {records.map((d, i) => (
              <tr key={i} className="border-t hover:bg-gray-50">
                <td className="p-2">{i + 1}</td>
                {/* <td className="p-2">{d?.code}</td> */}
                <td className="p-2">{d?.name}</td>
                <td className="p-2">{d?.appl_Gender}</td>
                <td className="p-2">{d?.unit}</td>
                <td className="p-2">{d?.carryForward_Input}</td>
                <td className="p-2">{d?.effectiveAfter_Input}</td>
                <td className="p-2">{d?.encashment_Input}</td>
                <td className="p-2">{d?.type}</td>
                <td className="p-2">{d?.reset_List}</td>

                <td className="p-2 flex justify-center gap-2">
                  {/* DELETE */}
                  <button
                    // onClick={() => {
                    //   setDeleteCatName(d?.name);
                    //   setModalVisible(true);
                    // }}
                    onClick={() => handleDeleteClick(d?.name)}
                    className="p-1 bg-red-500 hover:bg-red-600 text-white rounded text-xl"
                  >
                    <MdOutlineDelete />
                  </button>

                  {/* EDIT */}
                  {/* <button
                    onClick={()=>handleEditClick(d?.name)}
                    className="p-1 bg-blue-500 hover:bg-blue-600 text-white rounded"
                  >
                    <FaRegEdit />
                  </button> */}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* PAGINATION */}

      <div className="flex justify-end mt-4 gap-2">
        {numbers.map((n) => (
          <button
            key={n}
            onClick={() => setCurrentPage(n)}
            className={`px-3 py-1 border rounded ${
              currentPage === n ? "bg-blue-600 text-white" : "hover:bg-gray-200"
            }`}
          >
            {n}
          </button>
        ))}
      </div>

      {/* LOADER */}

      {loader && (
        <div className="flex justify-center mt-10">
          <FallingLines />
        </div>
      )}

      {/* POPUPS */}

      {showCreatePopup && (
        <CreateLeaveCatPopup handleClose={handleClose} getLeave={getLeave} />
      )}

      {showEditPopup && (
        <EditLeaveCatPopup
          LeaveCatName={LeaveCatName}
          handleClose={handleClose}
        />
      )}

      {/* {showDeletePopup && (
        <DeleteCategoryPop
        deleteCatName={deleteCatName}
        handleClose={handleClose}
        setModalVisible={setModalVisible}
        isModalVisible={isModalVisible}
        />
      )} */}

      {showDeletePopup && (
        <DeleteCategoryPop
          deleteCatName={deleteCatName}
          handleClose={handleClose}
        />
      )}
    </div>
  );
};

export default LeaveCategory;
